import { trackEvent } from '../analytics'
import { BuildMark } from '../components/Motifs'
import { AGENT_TOOLS, AI_TEAM, BUILD, BUILD_PROOF, EMAIL, OSS_REPOS } from '../data/content'

export default function Build() {
  const rows = BUILD_PROOF.filter((row) => row.enabled)
  const mail = `mailto:${EMAIL}?subject=${encodeURIComponent(BUILD.mailSubject)}`

  return (
    <section className="sheet" id="build">
      <div className="container">
        <div className="section-title">
          <BuildMark className="section-mark" />
          <h2>{BUILD.heading}</h2>
        </div>
        <p className="lede">{BUILD.intro}</p>
        <h3 className="block-head">{BUILD.teamHeading}</h3>
        <p className="team-intro">{BUILD.teamIntro}</p>
        <div className="team-list">
          {AI_TEAM.map((member) => (
            <div className="team-role" key={member.role}>
              <p className="team-name">{member.role}</p>
              <p>{member.body}</p>
            </div>
          ))}
        </div>
        <div className="agent-tools">
          <h3>{AGENT_TOOLS.heading}</h3>
          <p>{AGENT_TOOLS.body}</p>
          <p className="agent-logos-label">{AGENT_TOOLS.logosLabel}</p>
          <div className="agent-logos">
            {AGENT_TOOLS.logos.map((logo) => (
              <div className="agent-logo" key={logo.alt}>
                <img
                  className="agent-logo-light"
                  src={logo.lightSrc}
                  alt={logo.alt}
                  style={{ height: logo.height, width: 'auto' }}
                />
                <img
                  className="agent-logo-dark"
                  src={logo.darkSrc}
                  alt={logo.alt}
                  style={{ height: logo.height, width: 'auto' }}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="proof-list">
          {rows.map((row) => (
            <article className="proof-row" key={row.id}>
              <p className="proof-vertical">{row.vertical}</p>
              <div>
                <h3>{row.title}</h3>
                <p>{row.body}</p>
                {row.features ? (
                  <ul className="proof-features">
                    {row.features.map((f) => (
                      <li key={f.label}>
                        <div className="feature-head">
                          <span className="feature-label">{f.label}</span>
                          {f.status ? <span className="proof-status">{f.status}</span> : null}
                        </div>
                        {f.body ? <p className="feature-body">{f.body}</p> : null}
                      </li>
                    ))}
                  </ul>
                ) : null}
                {row.href && row.linkLabel ? (
                  <a className="tlink" href={row.href} target="_blank" rel="noopener noreferrer">
                    {row.linkLabel}
                  </a>
                ) : null}
              </div>
            </article>
          ))}
        </div>
        <h3 className="block-head">{BUILD.publishHeading}</h3>
        <div className="repo-list">
          {OSS_REPOS.map((repo) => (
            <div className="repo" key={repo.name}>
              <a href={repo.href} target="_blank" rel="noopener noreferrer">
                {repo.name}
              </a>
              <p>{repo.body}</p>
            </div>
          ))}
        </div>
        <p className="price-line">
          <span>{BUILD.priceLine}</span>
          <a className="tlink" href={mail} onClick={() => trackEvent('email_click', { location: 'build' })}>
            {BUILD.mailLabel}
          </a>
        </p>
      </div>
    </section>
  )
}
